import { useTranslation } from "react-i18next";
import type { BudgetConfigResponse } from "@/api";

export const BUDGET_SCOPES = ["platform", "team", "user"] as const;
export type BudgetScope = (typeof BUDGET_SCOPES)[number];

/** Who a budget applies to: "Platform default", the team's name, or the person's name. */
export function useBudgetTargetName() {
  const { t } = useTranslation("adminUsage");
  return (budget: BudgetConfigResponse): string => {
    if (budget.scope === "platform") return t("budgets.scope.platform");
    if (budget.scope === "team") return budget.teamName || t("budgets.unknownTarget");
    return budget.userName || budget.userEmail || t("budgets.unknownTarget");
  };
}
